import { gql } from "@apollo/client";

import { ActionItemCollapsibleFragment } from "./action-item-collapsible-fragment";

export default gql`
  ${ActionItemCollapsibleFragment}
  query getActionItemsCollapsibleQuery(
    $actionItemState: Int
    $fetchData: Boolean!
    $assigneeId: Int
    $actionItemIsComplete: Boolean
    $assigneeIds: [Int]
    $meetingGroupId: Int
    $flowId: Int
    $orderBy: String
    $orderContextType: String
    $orderContextId: Int
    $first: Int!
    $after: String
  ) {
    artifacts(
      artifactType: action_item
      actionItemIsComplete: $actionItemIsComplete
      actionItemAssignee: $assigneeId
      actionItemAssignees: $assigneeIds
      meetingGroupId: $meetingGroupId
      flowId: $flowId
      actionItemState: $actionItemState
      first: $first
      orderBy: $orderBy
      orderContextType: $orderContextType
      orderContextId: $orderContextId
      after: $after
    ) {
      pageInfo {
        hasNextPage
        endCursor
      }
      totalCount
      edges @include(if: $fetchData) {
        cursor
        node {
          ...ActionItemCollapsibleFragment
        }
      }
    }
  }
`;
